/*****************************************************************************/
/*  File Name: functionPage.js                                               */
/*  Date:      June 29 2021                                                  */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is a base template that we can use for functions pages   */
/*                                                                           */
/*****************************************************************************/

import React, { useState, useEffect } from 'react';

//import * as ROLES from '../../constants/roles';
//import { useNavigate } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

//import firebase from 'firebase/app';
import styles from './styles/nav.module.scss';
import { Divider, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, SwipeableDrawer } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import { useUserContext } from '../../context/userContext';
import { useROIContext } from '../../context/roiContext';
import * as ROLES from '../../constants/roles';
import AddUserDialog from '../User/addUserDialog';
import PasswordIcon from '@mui/icons-material/Password';
import ChangePasswordDialogAdmin from '../User/adminPasswordResetDialong';
import DatabaseManagementDialogAdmin from '../User/admindatabaseManagementDialog';

function NavigationMenu({ t }) {
  //Load all of the default component varaibles
  const { user, logoutUser } = useUserContext();
  const { clearROIData } = useROIContext();

  //const [loading, setLoading] = useState(true);
  const anchor = 'left';
  const [menuDrawer, setMenuDrawer] = useState(false);
  const [addUserDialog, setAddingUserDialog] = useState(false);
  const [passwordDialog, setPasswordDialog] = useState(false);
  const [databaseManagement, setDatabaseManagement] = useState(false);
  //Load all of the prop variables
  //const auth = useSelector((state) => state.firebase.auth);
  //console.log("user nav ->", user);
  //let navigate = useNavigate();

  useEffect(() => {
    //First thing we need to do is get the users company info
  }, []);
  if (user) {
    return (
      <div>
        <IconButton aria-haspopup='true' className={styles.menuIcon} aria-controls='menu-appbar' onClick={() => setMenuDrawer(true)}>
          <MenuIcon />
        </IconButton>
        <SwipeableDrawer anchor={anchor} open={menuDrawer} onClose={() => setMenuDrawer(false)} onOpen={() => setMenuDrawer(true)}>
          <List className={styles.list}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  clearROIData();
                  //navigate(ROUTES.LANDING);
                  setMenuDrawer(false);
                }}
              >
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText>Home</ListItemText>
              </ListItemButton>
            </ListItem>
            <Divider />
            {user.role === ROLES.SUPERADMIN ?
              <>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setAddingUserDialog(true);
                      setMenuDrawer(false);
                    }}
                  >
                    <ListItemIcon>
                      <PersonAddIcon />
                    </ListItemIcon>
                    <ListItemText>Add User</ListItemText>
                  </ListItemButton>
                </ListItem>
                <Divider />

                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setPasswordDialog(true);
                      setMenuDrawer(false);
                    }}
                  >
                    <ListItemIcon>
                      <PasswordIcon />
                    </ListItemIcon>
                    <ListItemText>Change Users Password</ListItemText>
                  </ListItemButton>
                </ListItem>
                <Divider />

                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setDatabaseManagement(true);
                      setMenuDrawer(false);
                    }}
                  >
                    <ListItemIcon>
                      <PasswordIcon />
                    </ListItemIcon>
                    <ListItemText>Database Management</ListItemText>
                  </ListItemButton>
                </ListItem>
                <Divider />

              </>

              : null}


            <ListItem disablePadding>
              <ListItemButton onClick={() => logoutUser()}>
                <ListItemIcon>
                  <AddBusinessIcon />
                </ListItemIcon>
                <ListItemText>Sign Out</ListItemText>
              </ListItemButton>
            </ListItem>
          </List>
        </SwipeableDrawer>
        <AddUserDialog openDialog={addUserDialog} setOpenDialog={setAddingUserDialog} />
        <ChangePasswordDialogAdmin openDialog={passwordDialog} setOpenDialog={setPasswordDialog} />
        {/* new dialogue */}
        <DatabaseManagementDialogAdmin openDialog={databaseManagement} setOpenDialog={setDatabaseManagement} />
      </div>
    );
  }
  return null;
}

export default withTranslation()(NavigationMenu);
